<script>
    import { onMount, afterUpdate } from 'svelte'
    import Grid from './components/Grid.svelte'
    import Slider from './components/Slider.svelte'
    import Examples from './components/Examples.svelte'
    import Explaination from './components/Explaination.svelte'

    let items = 30
    let columns = 5
    let expression = '3n+2'
    let validExpression = expression

    onMount(() => {
        if (window.innerWidth < 600) {
            columns = 3
            expression = '2n+4'
            validExpression = expression
        }
    })

    afterUpdate(() => {
        let style = document.getElementById('expression')

        if (style.sheet.cssRules.length) {
            style.sheet.deleteRule(0)
        }

        try {
            validExpression = expression
            style.sheet.insertRule(`article:nth-child(${expression}) { --background: var(--red) }`, 0)
        } catch (error) {
            validExpression = ''
        }
    })
</script>

<style>
    :global(body) {
        margin: 0;
        padding: 0;
        color: var(--blue);
        background-color: var(--silver);
        font-family: 'Roboto Mono', monospace;
        font-weight: 400;
    }

    :global(*) {
        box-sizing: border-box;
    }

    :global(:root) {
        --orange: #ffa822;
        --blue: #134e6f;
        --red: #ff6150;
        --green: #1ac0c6;
        --grey: #4f7286;
        --white: #fff;
        --silver: #f6f7f8;
    }

    a {
        color: inherit;
    }

    a:hover,
    a:focus {
        text-decoration: underline;
    }

    main {
        margin: 0 auto;
        padding: 4rem 2rem;
        max-width: 1240px;
        text-align: center;
    }

    h1 {
        color: var(--grey);
        font-size: 0.75rem;
        position: absolute;
        top: 1rem;
        left: 1rem;
        margin: 0;
        font-weight: 500;
        text-decoration: underline;
    }

    h2 {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: inherit;
        margin: 0 0 1rem;
        font-size: clamp(1.5rem, -0.775rem + 7.5vw, 2.5rem);
    }

    .bracket {
        display: inline-block;
        transform: translateY(-0.075em);
        transition: all 0.25s;
    }

    .expression {
        width: 3.6em;
        color: var(--green);
        border: none;
        height: 1.225em;
        margin: 0;
        padding: 0;
        background-color: transparent;
        font-weight: inherit;
        text-align: center;
        font-weight: 500;
        font-size: 0.85em;
        outline: none;
    }

    .expression:hover ~ .bracket,
    .expression:focus ~ .bracket {
        color: var(--green);
        transform: scale(1.125) translateY(-0.075em);
    }

    .sliders {
        display: inline-flex;
        gap: 1.5rem;
        padding: 1rem 1.5rem 0.875rem;
        width: 100%;
        margin-bottom: 2.5rem;
        justify-content: center;
        background-color: var(--white);
        border-radius: 5px;
        box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.025);
    }

    @media (min-width: 50rem) {
        .sliders {
            width: 80%;
        }
    }

    .order-1 {
        order: 1;
    }

    .order-2 {
        order: 2;
    }

    .order-3 {
        order: 3;
    }

    footer {
        color: var(--grey);
        font-size: 0.65rem;
        margin-top: 2.75rem;
    }
</style>

<main>
    <header>
        <h1>nthy</h1>
        <form on:submit|preventDefault>
            <h2>
                <span>:nth-child</span>
                <input class="expression order-2" name="value" type="text" bind:value={expression} />
                <span class="bracket order-1">(</span><span class="bracket order-3">)</span>
            </h2>
            <Examples on:update={({ detail }) => expression = detail} />
            <Explaination expression={validExpression} />
            <div class="sliders">
                <Slider label="Items" on:update={({ detail }) => (items = detail)} min="2" max="100" value={items} />
                <Slider
                    label="Columns"
                    on:update={({ detail }) => (columns = detail)}
                    min="1"
                    max="12"
                    value={columns} />
            </div>
        </form>
    </header>
    <Grid {items} {columns} />
    <footer>The little nth-child tool. &copy; <a href="https://lambry.com/">Lambry</a></footer>
</main>

<svelte:head>
    <style id="expression">
    </style>
</svelte:head>
